module.exports = __webpack_public_path__ + "img/watage_res_7.5b90199a.gif";